import axiosInstance from "./api";
import TokenService from "./token.service";
import router from '@/router'
import { localStorageName, gotoMemberLogin, ensureMerchantId } from '@/config/utils';
import store from '@/store';

// Map OO route names to the "from" values A&PCover.vue understands when the member site redirects back
const FROM_BY_ROUTE_NAME = {
  MyReward: 'myreward',
  MyCart: 'mycart',
  Profile: 'profile',
  Order: 'order',
  Queue: 'order',
};

// MTH080: check-merchant-and-branch is what ensureMerchantId() itself calls to repair
// MERCHANT_ID — it doesn't need the header, and guarding it here would recurse forever.
const MERCHANT_ID_GUARD_EXEMPT = ['/check-merchant-and-branch'];

const setup = () => {
  axiosInstance.interceptors.request.use(
    async (config) => {
      // const token = TokenService.getLocalAccessToken();
      const token = localStorage.getItem(localStorageName('token'));
      if (token) {
        config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      }
      var merchantCode = router.currentRoute.value.params.merchant_code ?? '';
      if (merchantCode == '') {
        merchantCode = store.state.merchantCode;
      }

      // MTH080: MERCHANT_ID can go missing well after page load (cross-tab logout,
      // a bfcache-restored page) — self-heal it here so every request behind
      // jwt.merchant_id_and_code is covered, not just the ones a caller remembered
      // to guard individually.
      if (!MERCHANT_ID_GUARD_EXEMPT.some((path) => (config.url || '').includes(path))) {
        const branchCode = router.currentRoute.value.params.branch_code || store.state.branchCode;
        await ensureMerchantId(branchCode);
      }
      var merchantId = localStorage.getItem(localStorageName('MERCHANT_ID'), '')

      config.headers["MerchantCode"] = merchantCode;  // for Spring Boot back-end
      config.headers["MerchantId"] = merchantId;  // for Spring Boot back-end

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    (res) => {
      return res;
    },
    async (err) => {
      const originalConfig = err.config;
      // Network/CORS errors have no response object — let callers handle them
      const status = err.response ? err.response.status : null;
      const redirectToMemberLogin = () => {
        // Read at call time (not capture time) so we get the live route and store state,
        // even if the 401/403 response arrives before checkMerchantAndBranch has finished.
        const currentRoute = router.currentRoute.value;
        const isKiosk = currentRoute.path.includes('/kiosk');
        if (isKiosk) {
          const code = store.state.merchantCode || currentRoute.params.merchant_code || '';
          const branchCode = store.state.branchCode || currentRoute.params.branch_code || '';
          router.push((code ? `/${code}` : '') + '/' + branchCode + '/sign-in');
        } else {
          gotoMemberLogin(FROM_BY_ROUTE_NAME[currentRoute.name] ?? 'order', currentRoute.query.queue ?? false, 'login');
        }
      };
      if (status === 401 && !originalConfig._retry) {
        TokenService.removeUser()
        localStorage.removeItem(localStorageName('token'));
        localStorage.removeItem(localStorageName('memberInfo'));
        localStorage.removeItem(localStorageName('SELECTED_REWARD'));
        localStorage.removeItem(localStorageName('PAYMENT_METHOD'));
        // localStorage.removeItem("ORDER_INFO");
        redirectToMemberLogin();
      }
      if (status === 403 && !originalConfig._retry) {
        localStorage.removeItem(localStorageName('token'));
        localStorage.removeItem(localStorageName('memberInfo'));
        localStorage.removeItem(localStorageName('SELECTED_REWARD'));
        localStorage.removeItem(localStorageName('PAYMENT_METHOD'));
        // localStorage.removeItem("ORDER_INFO");
        redirectToMemberLogin();
      }
      // if (originalConfig.url !== "/auth/login" && err.response) {
      //   // Access Token was expired
      //   if (err.response.status === 401 && !originalConfig._retry) {
      //     originalConfig._retry = true;

      //     try {
      //       const rs = await axiosInstance.post("/auth/refreshtoken", {
      //         refreshToken: TokenService.getLocalRefreshToken(),
      //       });

      //       const { accessToken } = rs.data;

      //       store.dispatch('auth/refreshToken', accessToken);
      //       TokenService.updateLocalAccessToken(accessToken);

      //       return axiosInstance(originalConfig);
      //     } catch (_error) {
      //       return Promise.reject(_error);
      //     }
      //   }
      // }

      return Promise.reject(err);
    }
  );
};

export default setup;